import {AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, Optional, Renderer2} from '@angular/core';
import {FormControl} from '@angular/forms';

import {NgFormControlErrorsContent} from './ng-form-control-errors-content';

export interface Error {
    name: string;
    message: string;
}

export interface Errors {
    [error: string]: string;
}
export class NgFormControlErrorsComponent implements AfterContentInit {

     errors: Errors;

    error: Error;
/**
 * @param {?} cd
 * @param {?} renderer
 * @param {?} controlErrorsContent
 */
constructor(private cd: ChangeDetectorRef,
private renderer: Renderer2,
private controlErrorsContent: NgFormControlErrorsContent) {

        if (!this.controlErrorsContent) {
            throw new Error(
                'control-errors must be used with a parent .control-errors-content directive');
        }
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        this.detectErrors();
        this.controlErrorsContent.onChange$.subscribe(() => this.detectErrors());
    }
/**
 * @return {?}
 */
detectErrors(): void {
        this.error = /** @type {?} */(( <Error>{}));

        if (this.invalid) {
            for (const /** @type {?} */ err in this.formControl.errors) {
                if (this.formControl.errors.hasOwnProperty(err)) {
                    if (this.errors[err]) {
                        this.error = {
                            name: err,
                            message: this.errors[err]
                        };
                    }
                }
            }
        }

        this.cd.markForCheck();
    }
/**
 * @return {?}
 */
get invalid(): boolean {
        return this.controlErrorsContent.invalid;
    }
/**
 * @return {?}
 */
get formControl(): FormControl {
        return this.controlErrorsContent.formControl;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'control-errors,[control-errors]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container>{{ error?.message }}</ng-container>
    `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: Renderer2, },
{type: NgFormControlErrorsContent, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'errors': [{ type: Input },],
};
}

function NgFormControlErrorsComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgFormControlErrorsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgFormControlErrorsComponent.ctorParameters;
/** @type {?} */
NgFormControlErrorsComponent.propDecorators;
/** @type {?} */
NgFormControlErrorsComponent.prototype.errors;
/** @type {?} */
NgFormControlErrorsComponent.prototype.error;
/** @type {?} */
NgFormControlErrorsComponent.prototype.cd;
/** @type {?} */
NgFormControlErrorsComponent.prototype.renderer;
/** @type {?} */
NgFormControlErrorsComponent.prototype.controlErrorsContent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
